import ingredientsImage from './assets/ingredients.png'
import menuPreviewImage from './assets/menu_preview.png'
import platesImage from './assets/plates.png'
import recipeCardImage from './assets/recipe_card.png'

export const HOW_TO_MENU = {
  title: 'Choose new recipes every week',
  text: 'Select 2 or more recipes from our 75+ recipes changing weekly',
  imageSource: menuPreviewImage,
  bullets: [
    'Healthy choices',
    'Cooked from 10-mins',
    'Vegan and vegetarian',
    'Gluten-free and diary-free',
    'and more...',
  ],
  tooltips: ['Swap ingredients'],
}

export const FRESH_INGREDIENTS = {
  title: 'Get fresh ingredients delivered',
  text: 'All ingredients delivered to your door in a recyclable box on a day you choose.',
  imageSource: ingredientsImage,
  tooltips: ['Pre-portioned ingredients', 'Insulated packaging'],
}

export const EASY_COOKING = {
  title: 'Enjoy easy cooking',
  text: 'Just follow the recipe card to cook a delicious meal after a busy day! ',
  imageSource: platesImage,
  additionalImageSource: recipeCardImage,
  tooltips: ['Try new ways of cooking'],
}

export const SECTION_TITLE = 'How Gousto works'

export const SUMMARY_SECTION = {
  title: 'Skip or cancel any time for free',
  text: 'No commitment. No cancellation fees. Skip a box or cancel your subscription online at anytime.',
  ctaText: 'Get started',
  captionText: 'All from just £3.14 per serving!',
}
